import axios from "../axiosInstance";

const sopGuideAPI = {
  store: (payload) => axios.post("admin/sop-guide/store", payload),
  getList: (params) => axios.get("admin/sop-guide/list", { params }),
  getAll: (params) => axios.get("admin/sop-guide/all-details", { params }),
  getDetails: (payload) => axios.post("admin/sop-guide/details", payload),
  update: (payload) => axios.post("admin/sop-guide/update", payload),
  
  delete: (payload) => axios.post("admin/sop-guide/delete", payload),
  deleteAttachment: (payload) => axios.post("admin/sop-guide/delete-attachment", payload),
};

export default sopGuideAPI;
